import { createSlice } from "@reduxjs/toolkit";
const hierarchiesSlice = createSlice({
    name: 'hierarchies',
    initialState: {
        hierarchiesList: [],
        hierarchiesDetails: []
    },
    reducers: {
        setHierarchiesList: (state, action) => {
            state.hierarchiesList = action.payload.hierarchiesList
        },
        setHierarchiesDetails: (state, action) => {
            state.hierarchiesDetails = action.payload.hierarchiesDetails
        }
    }
});
export const addHierarchiesList = hierarchiesSlice.actions.setHierarchiesList;
export const addHierarchiesDetails = hierarchiesSlice.actions.setHierarchiesDetails;
export default hierarchiesSlice.reducer;
